module.exports = __webpack_public_path__ + "static/media/235-ER18_1g-JwthCseLkOrVNz9lal7OaAU48gsUG4.2a23f8a6.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/235-ER18_1g-JwthCseLkOrVNz9lal7OaAU48gsUG4
// module id = 745
// module chunks = 0